import { SpacesState } from './spaces.types';

/**
 *  Holding the state of the spaces.
 */
export const State: { spaces: SpacesState; } = {
    spaces: {
        added: {},
        valid: false,
        configData: {
            floors: {},
            insulation_levels: {},
            outdoor_unit_locations: {},
        },
    },
};
